import { SystemConfigResponse } from 'src/store/src/general/system/types';
import { BaseApiResponse } from 'src/api/types';

/**
 * Fetches information about actual system configuration
 */
export async function getSystemConfig(): Promise<BaseApiResponse<SystemConfigResponse>> {
    // Default options are marked with *
    const response = await fetch('api_react/systemInfo.php', {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'include', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
        }
    });

    const dataPrimary = await response.text();

    if (dataPrimary === 'Unauthorized access!') {
        return {
            data: null,
            errorCode: 1,
            success: false,
            message: 'Unauthorized access!'
        };
    }

    const dataParsed = JSON.parse(dataPrimary);
    try {
        return { data: dataParsed, errorCode: null, success: true, message: 'Zdobyto dane' };
    } catch (e) {
        return { data: null, errorCode: 500, success: false, message: dataParsed };
    }
}
